import axios from './axios.setup.js';
import * as Types from './account.service.js';

/**
 * @typedef Company
 * @property {number} id
 * @property {string} uuid
 * @property {boolean} active
 * @property {string} full_name
 * @property {string | null} first_name
 * @property {string | null} last_name
 * @property {number | null} legacy_id
 * @property {string | null} email
 * @property {string | null} pec
 * @property {string} country
 * @property {string | null} city
 * @property {string | null} address
 * @property {string | null} profile_picture
 * @property {number | null} tax_id
 * @property {string | null} type : null
 * @property {number | null} vat_id : null
 * @property {string | null} zip_code : null
 * @property {number | null} archicons_id
 * @property {number | null} accounts_count
 * @property {string} created_at
 * @property {string} updated_at : "2024-12-04 14:00:04"
 * @property {string | null} deleted_at
 */

/**
 * Get all companies
 * @param {{mini: boolean}} options
 * @returns {Promise<Company[]>}
 */
export async function getAll(options) {
  let url = '/companies';
  if (options?.mini) {
    url += '?mini=1';
  }

  let res = await axios.get(url);
  return res.data;
}

/**
 * Gets a company by its id
 * @param {number} id
 * @returns {Promise<Company>}
 */
export async function get(id) {
  let res = await axios.get("/companies/" + id);
  return res.data;
}

/**
 * Get all accounts related to a specific company
 * @param {number} companyId
 * @returns {Promise<Types.Account[]>}
 */
export async function getAccounts(companyId) {
  let res = await axios.get("/companies/" + companyId + "/accounts");
  return res.data;
}

/**
 * Get all accounts related to a specific company
 * @param {number} companyId
 * @returns {Promise<Array<{uuid: string, unseen_count: number}>>}
 */
export async function getAccountsUnseenMessages(companyId) {
  let res = await axios.get("/companies/" + companyId + "/accounts/unseen-counts");
  return res.data;
}

/**
 * @param {Company} company
 */
export async function create(company) {
  if (company.id != null) {
    throw new Error("Cannot create a company that already has an id.");
  }

  let res = await axios.post('/companies', company);
  return res.data;
}

/**
 * @param {Company} company
 */
export async function update(company) {
  if (company.id == null) {
    throw new Error("Cannot update a company that doesn't have an id.");
  }

  let res = await axios.put('/companies/' + company.id, company);
  return res.data;
}

/**
 * @param {Company} company
 */
export async function remove(id) {
  let res = await axios.delete('/companies/' + id);
  return res.data;
}
